import { IUserModel } from "@/types";
import Vue from "vue";
import { userMapActions } from "@/store/modules/user";

interface SelectOption {
  title: string;
  text: string;
  email?: string;
  type?: "phone" | "email";
}
interface Messages {
  title: string;
  contacts: SelectOption[];
}

interface IData {
  messages: Messages[];
}
export default Vue.extend({
  data(): IData {
    return {
      messages: []
    };
  },

  mounted() {
    this.getContactDetails();
  },

  methods: {
    ...userMapActions(["getContactUsDetails"]),

    async getContactDetails() {
      try {
        const response = await this.getContactUsDetails({
          atlasAdmin__exists: true,
          role__in: "underwriting,billing",
          showOnContactUs: true,
          deleted: false,
          isBanned: false,
          status: "active",
          isRestricted__exists: false
        });
        this.formatContactData(response);
      } catch (error) {
        this.$appNotifyError(error.message);
        this.$bugSnagClient.notify(error);
      }
    },

    formatContactData(users: IUserModel[]) {
      const underwritingData: { title: string; contacts: SelectOption[] } = {
        title: "Underwriting",
        contacts: []
      };

      const billingData: { title: string; contacts: SelectOption[] } = {
        title: "Billing",
        contacts: []
      };

      users.forEach((user: IUserModel) => {
        const jobTitle = user.atlasAdmin?.title;
        const extension = user.phone?.extension;
        const userData: SelectOption = {
          title: jobTitle
            ? `${user.firstName} ${user.lastName} - ${jobTitle}`
            : `${user.firstName} ${user.lastName}`,
          text: extension ? `Ext ${extension}` : "",
          email: user.email,
          type: "email"
        };
        if (user.role === "underwriting") {
          console.info({ userData });
          underwritingData.contacts.push(userData);
        } else if (user.role === "billing") {
          billingData.contacts.push(userData);
        }
      });

      // Fall back to the department's toll-free line when no admin is listed.
      if (!underwritingData.contacts.length) {
        underwritingData.contacts.push({
          title: "Underwriting",
          text: "888-786-0003",
          type: "phone"
        });
      }
      if (!billingData.contacts.length) {
        billingData.contacts.push({
          title: "Billing",
          text: "888-786-0003",
          type: "phone"
        });
      }

      this.messages = [billingData, underwritingData];
    }
  }
});
